import { combineReducers } from 'redux';
import auth from './auth';
import usermanagement from './usermanagement'
import reportmanagement from './reportmanagement'
import assignfeaturetothegroup from './assignfeaturetothegroup'
import assignreporttothegroup from './assignreporttothegroup'
import canvascreation from './canvascreation'
import restapi from './restapi'
import reportscheduler from './reportscheduler'
import newgroup from './newgroup'
import sessionlogout from './sessionlogout'
import logowhitelisting from "./logowhitelisting";
import inventoryAction from './inventoryAction';
import inventoryBuilder from "./inventoryBuilder";
import inventoryDetail from "./inventoryDetail";
import listOfTables from "./listOfTables";
import saveConnection from "./saveConnection";
import saveTemplate from "./saveTemplate";
import schemaExplorer from "./schemaExplorer";
import toggleFavorite from "./toggleFavorite";
import uniqueValues from "./uniqueValues";

const reducers = combineReducers({
    auth, usermanagement, reportmanagement, assignfeaturetothegroup, assignreporttothegroup, canvascreation, restapi, reportscheduler, newgroup, sessionlogout, logowhitelisting,
    inventoryAction,
    inventoryBuilder,
    inventoryDetail,
    listOfTables,
    saveConnection,
    saveTemplate,
    schemaExplorer,
    toggleFavorite,
    uniqueValues,

});

export default reducers;